import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useApiClient } from '@/api/clients/useApiClient.util.ts';
import { HTTP_STATUS } from '@/api/ErrorCode.model.ts';
import { SettlementsDto } from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';

type Options = {
  enabled?: boolean;
};

type Return = {
  isError: boolean;
  isForbidden: boolean;
  isLoading: boolean;
  settlements?: SettlementsDto;
};

export const useGetSettlements = (options?: Options): Return => {
  const { settlementsApi } = useApiClient();

  const { data, error, isError, isLoading } = useQuery<SettlementsDto, AxiosError>({
    enabled: options?.enabled ?? true,
    queryFn: async () => {
      const { data } = await settlementsApi.getSettlements();
      return data;
    },
    queryKey: [QueryKeyEnum.SETTLEMENTS.ALL],
  });

  return {
    isError,
    isForbidden: error?.response?.status === HTTP_STATUS.FORBIDDEN,
    isLoading,
    settlements: data,
  };
};
